import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { InputFootnote } from '@src/elements/input/input-footnote'

import './password-requirements.sass'

@Component
export class PasswordRequirements extends Vue {

  @Prop({ required: true })
  highlightRequirements: {
    minLength: boolean,
    oneLetter: boolean,
    oneNumber: boolean,
    sameAsConfirm: boolean
  }

  render (h: CreateElement) {
    return <div class='row'>
      <InputFootnote class='password-requirements' direction='column'>
        <span>{this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.REQUIREMENTS.DESCRIPTION')}</span>
        <span class={this.highlightRequirements.minLength ? 'highlight' : ''}>&#8226; {this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.REQUIREMENTS.1')}</span>
        <span class={this.highlightRequirements.oneLetter ? 'highlight' : ''}>&#8226; {this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.REQUIREMENTS.2')}</span>
        <span class={this.highlightRequirements.oneNumber ? 'highlight' : ''}>&#8226; {this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.REQUIREMENTS.3')}</span>
        <span class={this.highlightRequirements.sameAsConfirm ? 'highlight' : ''}>&#8226; {this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.REQUIREMENTS.4')}</span>
      </InputFootnote>
    </div>
  }
}
